import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { CreditRevalDetailsImpl } from "../model/impl/CreditRevalDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class CreditRevalDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: CreditRevalDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        CreditRevalDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.lastCreditRevalTime != null) {
      this.baseEncoder.writeStartFid(901, streamout);
      this.baseEncoder.writeObject(
        false,
        CreditRevalDetailsImplEncoder.fidTypeMap.get(901),
        false,
        encodable.lastCreditRevalTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(901, streamout);
    }
    /*Object encoding*/
    if (encodable.lastCreditType != null) {
      this.baseEncoder.writeStartFid(902, streamout);
      this.baseEncoder.writeObject(
        false,
        CreditRevalDetailsImplEncoder.fidTypeMap.get(902),
        false,
        encodable.lastCreditType,
        streamout,
      );
      this.baseEncoder.writeEndFid(902, streamout);
    }
    /*Object encoding*/
    if (encodable.lastCreditStatus != null) {
      this.baseEncoder.writeStartFid(903, streamout);
      this.baseEncoder.writeObject(
        false,
        CreditRevalDetailsImplEncoder.fidTypeMap.get(903),
        false,
        encodable.lastCreditStatus,
        streamout,
      );
      this.baseEncoder.writeEndFid(903, streamout);
    }
    /*Object encoding*/
    if (encodable.lastCreditFailureReason != null) {
      this.baseEncoder.writeStartFid(904, streamout);
      this.baseEncoder.writeObject(
        false,
        CreditRevalDetailsImplEncoder.fidTypeMap.get(904),
        false,
        encodable.lastCreditFailureReason,
        streamout,
      );
      this.baseEncoder.writeEndFid(904, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,CreditRevalDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [901, "java.lang.Long"],
    [902, "com.bcdfx.model.CreditType"],
    [903, "com.bcdfx.model.CreditStatus"],
    [904, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: CreditRevalDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CreditRevalDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 901: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CreditRevalDetailsImplEncoder.fidTypeMap.get(901),
            streamin,
          );
          encodable.lastCreditRevalTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 902: {
          /*Object encoding*/
          let val: CubiqTS.CreditType = this.baseEncoder.readObject(
            false,
            false,
            CreditRevalDetailsImplEncoder.fidTypeMap.get(902),
            streamin,
          );
          encodable.lastCreditType = <CubiqTS.CreditType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 903: {
          /*Object encoding*/
          let val: CubiqTS.CreditStatus = this.baseEncoder.readObject(
            false,
            false,
            CreditRevalDetailsImplEncoder.fidTypeMap.get(903),
            streamin,
          );
          encodable.lastCreditStatus = <CubiqTS.CreditStatus>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 904: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CreditRevalDetailsImplEncoder.fidTypeMap.get(904),
            streamin,
          );
          encodable.lastCreditFailureReason = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,CreditRevalDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return CreditRevalDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
